






import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';

/**
 * `SiteMap Footer` - SiteMap for OneWeb - This component contains the sitemap sections for the footer.
 */

export default ComponentInitializeDispatcher.extend({
  name: 'owc-site-map',
  components: {
    SlotContainer,
  },
});
